class NewsletterPopup extends HTMLElement {
  connectedCallback() {
    this._subscribed = this.hasAttribute('data-subscribed');
    this._forceOpen = this._subscribed || this.hasAttribute('data-force-open');

    if (this._subscribed) {
      localStorage.setItem('cuore:popup-subscribed', 'true');
    }

    if (this._forceOpen) {
      this.show();
    } else if (this._shouldShow()) {
      const delay = Number(this.dataset.delay || 4) * 1000;
      setTimeout(() => this.show(), delay);
    }

    this.querySelector('.newsletter-popup__close')
      ?.addEventListener('click', () => this.dismiss());

    this.querySelector('.newsletter-popup__no-thanks')
      ?.addEventListener('click', () => this.dismiss());

    this.querySelector('.newsletter-popup__overlay')
      ?.addEventListener('click', () => {
        if (!this._subscribed) this.dismiss();
      });

    this._onKeyUp = (e) => { if (e.key === 'Escape' && this._open) this.dismiss(); };
    document.addEventListener('keyup', this._onKeyUp);
  }

  disconnectedCallback() {
    document.removeEventListener('keyup', this._onKeyUp);
  }

  _shouldShow() {
    if (localStorage.getItem('cuore:popup-subscribed') === 'true') return false;
    const dismissed = localStorage.getItem('cuore:popup-dismissed');
    if (!dismissed) return true;
    if (this.hasAttribute('data-show-once')) return false;
    const days = Number(this.dataset.days || 30);
    return Date.now() - Number(dismissed) > days * 86_400_000;
  }

  show() {
    this.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
    this._open = true;

    const dialog = this.querySelector('.newsletter-popup__dialog');
    const focusTarget =
      dialog.querySelector('input[type="email"]') || dialog.querySelector('button');

    if (typeof trapFocus === 'function') trapFocus(dialog, focusTarget);
  }

  dismiss() {
    this.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    this._open = false;

    if (typeof removeTrapFocus === 'function') removeTrapFocus();

    if (!this._subscribed) {
      localStorage.setItem('cuore:popup-dismissed', String(Date.now()));
    }
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
